<template>
<div class="p-2">
    <div class="form-row">
        <div class="mui-textfield col-6">
            <span class="textfield">{{ rate }}</span>
            <label>{{ plan.method == 'set-balance' ? 'Balance' : 'Accrual Rate' }}</label>
        </div>
        <div class="mui-textfield col-6">
            <span class="textfield">{{ isBase ? '0 years' : startsAt(tier) }}</span>
            <label>Starts at</label>
        </div>
    </div>

    <template v-if="isBase">
        <div class="form-row">
            <div class="mui-textfield col-6">
                <span class="textfield" v-if="Number(plan.accrual_waiting_hours) > 0">{{ Number(plan.accrual_waiting_hours) }} hours worked</span>
                <span class="textfield" v-else>{{ plan.accrual_waiting_days }} days</span>
                <label>Accrual Waiting Period</label>
            </div>
            <div class="mui-textfield col-6">
                <span class="textfield">{{ plan.usage_waiting_days }} days</span>
                <label>Usage Waiting Period</label>
            </div>
        </div>

        <div class="form-row">
            <div class="mui-textfield col-6">
                <span class="textfield">{{ Number(plan.min_hours_per_period) }} hours</span>
                <label>Minimum Hours per Pay Period</label>
            </div>
        </div>
    </template>

    <h4 class="theading mb-2">Rollover Rules</h4>
    <div class="form-row">
        <div class="mui-textfield col-6">
            <span class="textfield">{{ tier.rollover_enabled ? 'Yes' : 'No' }}</span>
            <label>Enable Rollover</label>
        </div>
        <div class="mui-textfield col-6" v-if="tier.rollover_enabled">
            <span class="textfield">{{ limit(tier.max_rollover_hours) }}</span>
            <label>Max Hours to Rollover</label>
        </div>
    </div>

    <h4 class="theading mb-2">Balance and Usage Limits</h4>
    <div class="form-row">
        <div class="mui-textfield col-6">
            <span class="textfield">{{ limit(tier.max_balance_hours) }}</span>
            <label>Annual Balance Limit</label>
        </div>
        <div class="mui-textfield col-6">
            <span class="textfield">{{ limit(tier.max_accrued_per_year) }}</span>
            <label>YTD Accrual Limit</label>
        </div>
    </div>
    <div class="form-row">
        <div class="mui-textfield col-6">
            <span class="textfield">{{ limit(tier.max_taken_per_year) }}</span>
            <label>YTD Taken Limit</label>
        </div>
    </div>
</div>
</template>

<script>
import { startsAt } from './tiers'

export default {
    props: ['tier', 'plan', 'isBase', ],
    computed: {
        rate() {
            const hours = Number(this.tier.accrual_hours)
            if (this.plan.method == 'hours-worked') {
                return `${hours} per ${Number(this.tier.per_hours_worked)} hours worked`
            }
            if (this.plan.method == 'pay-period') {
                return `${hours} hours per pay cycle`
            }
            return `${hours} hours`
        },
    },
    methods: {
        startsAt,
        limit(value) {
            return value == null ? 'No limit' : `${Number(value)} hours`
        },
    },
}
</script>
